/**
 * Extract URLs from text using regex
 * @param {string} text - Text containing URLs
 * @returns {string[]} Array of extracted URLs
 */
export const extractUrls = (text) => {
  if (!text) return [];
  
  const lines = text.split('\n');
  const urls = [];

  for (let i = 0; i < lines.length; i++) {
    const urlRegex = /http[s]?:\/\/[^\s]+/;
    const urlMatch = lines[i].match(urlRegex);

    if (urlMatch) {
      urls.push(urlMatch[0]);
    }
  }

  return urls;
};

/**
 * Compare URLs from user input with URLs from order objects
 * @param {string[]} userUrls - URLs extracted from user input
 * @param {Object[]} orders - Array of order objects with url property
 * @returns {boolean} True if URLs match
 */
export const compareUrlsWithOrders = (userUrls, orders) => {
  if (!Array.isArray(orders)) {
    return false;
  }

  // Deduplicate orderUrls — a customer may have multiple orders sharing
  // the same URL (e.g. same item ordered twice), so we compare unique URLs only.
  const orderUrls = [...new Set(orders.map(order => order.url).filter(Boolean))];
  
  if (userUrls.length !== orderUrls.length) {
    return false;
  }

  // Use Set for efficient comparison (no sorting needed!)
  const set2 = new Set(orderUrls);
  return userUrls.every(url => set2.has(url));
};